import type { RxJsonSchema } from 'rxdb'

/**
 * SpaceOrder Document Type
 * One user's private position for a root Space in the sidebar.
 * Backend domain name: UserProjectOrder. Sync route: /api/sync/spaceOrders.
 */
export interface SpaceOrderDocument {
  id: string
  envId: string
  userId: string
  projectId: string // always a root Space — nested projects use Project.sortOrder
  sortOrder: string // LexoRank
  isDeleted: boolean

  // Audit fields
  createdOn: number
  createdBy: string
  updatedOn: number
  updatedBy: string
  deletedOn?: number | null
  deletedBy?: string | null

  // RxDB replication metadata
  updatedAt?: number
}

/**
 * RxDB Schema for SpaceOrder
 */
export const spaceOrderSchema: RxJsonSchema<SpaceOrderDocument> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 36,
    },
    envId: {
      type: 'string',
      maxLength: 36,
    },
    userId: {
      type: 'string',
      maxLength: 36,
    },
    projectId: {
      type: 'string',
      maxLength: 36,
    },
    sortOrder: {
      type: 'string',
      maxLength: 100,
    },
    isDeleted: {
      type: 'boolean',
      default: false,
    },

    // Audit fields
    createdOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    createdBy: {
      type: 'string',
      maxLength: 36,
    },
    updatedOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    updatedBy: {
      type: 'string',
      maxLength: 36,
    },
    deletedOn: {
      type: ['number', 'null'],
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    deletedBy: {
      type: ['string', 'null'],
      maxLength: 36,
    },

    // RxDB replication metadata
    updatedAt: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
  },
  required: [
    'id',
    'envId',
    'userId',
    'projectId',
    'sortOrder',
    'isDeleted',
    'createdOn',
    'createdBy',
    'updatedOn',
    'updatedBy',
  ],
  indexes: [
    'envId',
    'updatedOn',
    ['envId', 'isDeleted'],
    ['envId', 'userId'],
  ],
}
